module.exports = __webpack_public_path__ + "img/question9.ed1e3305.png";